import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  value?: any[];
  item?: any;
  disabled?: boolean;
}
interface Emits {
  (e: 'input', data: Props['value']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogFilterItem',
  props: {
    value: { default: () => [] },
    item: { default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any[], item: any, disabled: boolean };




const valueLocal = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit('input', value);
  },
});

return { __sfc: true,props, emit, valueLocal }
}

})